import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import RaisedButton from 'material-ui/RaisedButton';
import get from 'lodash/get';
import includes from 'lodash/includes';
import AuthService from '../../services/AuthService';
import { UserActions } from '../../actions';

export class Dashboard extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  static propTypes = {
    auth: PropTypes.instanceOf(AuthService)
  }

  componentWillMount() {
    const { dispatch, user } = this.props;
    if (!user || !user.company) {
      dispatch(UserActions.getCompany());
    }
  }

  goto = (newPath) => {
    browserHistory.push(newPath);
  }

  render() {
    const { user } = this.props;

    const orders = get(user, 'company.data.orders', get(user, 'company.features.orders', false));
    const fleet = get(user, 'company.data.trackers', get(user, 'company.features.trackers', false));
    const role = get(user, 'profile.roles', 'read-only');

    const all = ['super-admin', 'carrier-admin', 'shipper-admin'];
    const some = ['super-admin', 'carrier-admin'];

    return (
      <div>
        <div className="row">
          <div className="col s12 align-center">
            <h3>Dashboard</h3>
          </div>
        </div>
        <div className="row">
          {orders &&
          <div className="col s12 m3">
            <RaisedButton primary={true} label="Orders" fullWidth onClick={() => { this.goto('/orders') }} />
          </div>
          }
          {fleet &&
          <div className="col s12 m3">
            <RaisedButton primary={true} label="Trackers" fullWidth onClick={() => { this.goto('/fleet/trackers') }} />
          </div>
          }
          <div className="col s12 m6" />
        </div>
        {includes(all, role) &&
        <div className="row">
          <div className="col s12 m3">
            <RaisedButton primary={true} label="Users" fullWidth onClick={() => { this.goto('/admin/users') }} />
          </div>
          {includes(some, role) &&
          <div className="col s12 m3">
            <RaisedButton primary={true} label="Drivers" fullWidth onClick={() => { this.goto('/admin/drivers') }} />
          </div>
          }
          {includes(some, role) &&
          <div className="col s12 m3">
            <RaisedButton primary={true} label="Shippers" fullWidth onClick={() => { this.goto('/admin/companies') }} />
          </div>
          }
        </div>
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth.auth,
    user: state.user
  }
}

export default connect(mapStateToProps)(Dashboard);


// WEBPACK FOOTER //
// ./src/containers/Dashboard/index.js